'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    height: 60px;\n    border-bottom: 1px solid ', ';\n\n    @media (min-width: ', ') {\n        height: 80px;\n    }\n\n    &:after {\n        content: \'\';\n        width: 100%;\n        height: 100%;\n        background-color: ', ';\n        opacity: ', ';\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: -1;\n    }\n'], ['\n    height: 60px;\n    border-bottom: 1px solid ', ';\n\n    @media (min-width: ', ') {\n        height: 80px;\n    }\n\n    &:after {\n        content: \'\';\n        width: 100%;\n        height: 100%;\n        background-color: ', ';\n        opacity: ', ';\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: -1;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    position: relative;\n    height: 60px;\n    box-sizing: border-box;\n    width: 100%;\n    z-index: 10;\n    align-items: center;\n    box-shadow: 0 2px 2px 0 ', ';\n    @media (min-width: ', ') {\n        height: 80px;\n        opacity: 1;\n    }\n'], ['\n    display: flex;\n    position: relative;\n    height: 60px;\n    box-sizing: border-box;\n    width: 100%;\n    z-index: 10;\n    align-items: center;\n    box-shadow: 0 2px 2px 0 ', ';\n    @media (min-width: ', ') {\n        height: 80px;\n        opacity: 1;\n    }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    align-items: center;\n'], ['\n    align-items: center;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    display: inherit;\n    position: absolute;\n'], ['\n    display: inherit;\n    position: absolute;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    color: ', ';\n    font-family: ', ';\n    font-weight: ', ';\n    font-size: ', ';\n    line-height: ', ';\n'], ['\n    color: ', ';\n    font-family: ', ';\n    font-weight: ', ';\n    font-size: ', ';\n    line-height: ', ';\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    position: absolute;\n    left: 0;\n    padding-left: ', 'px;\n    cursor: pointer;\n    @media (min-width: ', ') {\n        padding: 0 ', 'px;\n    }\n'], ['\n    position: absolute;\n    left: 0;\n    padding-left: ', 'px;\n    cursor: pointer;\n    @media (min-width: ', ') {\n        padding: 0 ', 'px;\n    }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n    position: absolute;\n    right: 0;\n    top: 25%;\n'], ['\n    position: absolute;\n    right: 0;\n    top: 25%;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n    &:after {\n        content: \'\';\n        color: ', ';\n        background: ', ';\n        position: absolute;\n        bottom: 0;\n        top: 50px;\n        width: 100%;\n        height: 4px;\n    }\n'], ['\n    &:after {\n        content: \'\';\n        color: ', ';\n        background: ', ';\n        position: absolute;\n        bottom: 0;\n        top: 50px;\n        width: 100%;\n        height: 4px;\n    }\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n    position: relative;\n    margin-left: ', 'px;\n    margin-right: ', 'px;\n    ', ';\n    ', ';\n    ', ';\n\n    &:hover {\n        ', ';\n    }\n'], ['\n    position: relative;\n    margin-left: ', 'px;\n    margin-right: ', 'px;\n    ', ';\n    ', ';\n    ', ';\n\n    &:hover {\n        ', ';\n    }\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n    flex: 1;\n'], ['\n    flex: 1;\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n    ', ';\n    ', ';\n    position: ', ';\n    right: 0;\n    margin-left: ', 'px;\n    margin-right: ', 'px;\n\n    &:hover {\n        display: block;\n    }\n\n    @media (min-width: ', ') {\n        margin-left: ', 'px;\n        margin-right: ', 'px;\n    }\n'], ['\n    ', ';\n    ', ';\n    position: ', ';\n    right: 0;\n    margin-left: ', 'px;\n    margin-right: ', 'px;\n\n    &:hover {\n        display: block;\n    }\n\n    @media (min-width: ', ') {\n        margin-left: ', 'px;\n        margin-right: ', 'px;\n    }\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n    position: absolute;\n    cursor: pointer;\n    ', '\n\n'], ['\n    position: absolute;\n    cursor: pointer;\n    ', '\n\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n    color: ', ';\n    background-color: ', ';\n    ', '\n'], ['\n    color: ', ';\n    background-color: ', ';\n    ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _getSize = require('../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../constants/sizes');

var _text = require('../../constants/text');

var _link = require('../../atoms/link');

var _link2 = _interopRequireDefault(_link);

var _light = require('../../atoms/icons/logo/light');

var _light2 = _interopRequireDefault(_light);

var _colors = require('../../constants/colors');

var _menu = require('../lists/menu');

var _menu2 = _interopRequireDefault(_menu);

var _chat = require('../../atoms/icons/chat');

var _chat2 = _interopRequireDefault(_chat);

var _screenSize = require('../../constants/screenSize');

var _isMobile = require('../../helpers/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

var _isTablet = require('../../helpers/isTablet');

var _isTablet2 = _interopRequireDefault(_isTablet);

var _isDesktop = require('../../helpers/isDesktop');

var _isDesktop2 = _interopRequireDefault(_isDesktop);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _scroll = require('../../layouts/scroll');

var _alignments = require('../../constants/alignments');

var _primaryButton = require('../../atoms/buttons/primaryButton');

var _primaryButton2 = _interopRequireDefault(_primaryButton);

var _secondaryButton = require('../../atoms/buttons/secondaryButton');

var _secondaryButton2 = _interopRequireDefault(_secondaryButton);

var _opacity = require('../../constants/opacity');

var _opacity2 = _interopRequireDefault(_opacity);

var _LanguageToggle = require('../LanguageToggle');

var _LanguageToggle2 = _interopRequireDefault(_LanguageToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AppBarWrapper = _styledComponents2.default.div(_templateObject, _colors.Colors.StrokeLight, _screenSize.ScreenSize.md, function (_ref) {
    var afterScrollColor = _ref.afterScrollColor;
    return afterScrollColor ? afterScrollColor : _colors.Colors.LightMode;
}, function (_ref2) {
    var opacity = _ref2.opacity;
    return opacity ? opacity : _opacity2.default.None;
});

var AppBarComponent = _styledComponents2.default.div(_templateObject2, _colors.Colors.StrokeLight, _screenSize.ScreenSize.md);

var verticalCenterStyles = (0, _styledComponents.css)(_templateObject3);

var AppBarLinks = _styledComponents2.default.div(_templateObject4);

var menuLinkFontStyleStyles = (0, _styledComponents.css)(_templateObject5, function (_ref3) {
    var color = _ref3.color;
    return color ? color : _colors.Colors.LightMode;
}, _text.TextSizes.HeaderFontFamily, _text.TextSizes.WeightSemiBold, _text.TextSizes.P2FontSize, _text.TextSizes.P2LineHeight);

var LogoWrapper = _styledComponents2.default.div(_templateObject6, function (_ref4) {
    var mobile = _ref4.mobile;
    return (0, _getSize2.default)(mobile ? _sizes.Sizes.xs : _sizes.Sizes.sm);
}, _screenSize.ScreenSize.md, (0, _getSize2.default)(_sizes.Sizes.md));

var ButtonContainer = (0, _styledComponents2.default)(_container2.default)(_templateObject7);

var navLinkHoverStyles = (0, _styledComponents.css)(_templateObject8, function (_ref5) {
    var color = _ref5.color;
    return color ? color : _colors.Colors.LightMode;
}, function (_ref6) {
    var hoverColor = _ref6.hoverColor;
    return hoverColor ? hoverColor : _colors.Colors.Primary;
});

var NavLink = (0, _styledComponents2.default)(_link2.default)(_templateObject9, (0, _getSize2.default)(_sizes.Sizes.xs), (0, _getSize2.default)(_sizes.Sizes.sm), menuLinkFontStyleStyles, verticalCenterStyles, function (_ref7) {
    var active = _ref7.active,
        disable = _ref7.disable;
    return active && !disable && navLinkHoverStyles;
}, navLinkHoverStyles);

var Spacer = _styledComponents2.default.div(_templateObject10);

var NavMenu = (0, _styledComponents2.default)(_menu2.default)(_templateObject11, menuLinkFontStyleStyles, verticalCenterStyles, function (_ref8) {
    var mobile = _ref8.mobile,
        displayUserName = _ref8.displayUserName;
    return mobile ? 'initial' : displayUserName ? 'absolute' : 'relative';
}, (0, _getSize2.default)(_sizes.Sizes.xxs), (0, _getSize2.default)(_sizes.Sizes.xs), _screenSize.ScreenSize.md, (0, _getSize2.default)(_sizes.Sizes.xs), (0, _getSize2.default)(_sizes.Sizes.sm));

var ChatContainer = (0, _styledComponents2.default)(_container2.default)(_templateObject12, function (_ref9) {
    var desktop = _ref9.desktop,
        mobile = _ref9.mobile;
    return desktop ? 'position: absolute;\n    top: 25px;\n    right: 350px;' : mobile ? '\n    top: 15px;\n    right: 50px;' : '\n\ttop: 25px;\n    right: 60px;\n\t';
});

var AppBarSecondaryButton = (0, _styledComponents2.default)(_secondaryButton2.default)(_templateObject13, function (_ref10) {
    var color = _ref10.color;
    return color ? color : _colors.Colors.LightMode;
}, function (_ref11) {
    var bgColor = _ref11.bgColor;
    return bgColor ? bgColor : 'transparent';
}, function (_ref12) {
    var borderColor = _ref12.borderColor;
    return borderColor && 'border: 2px solid ' + borderColor + ';';
});

var AppBar = function (_Component) {
    _inherits(AppBar, _Component);

    function AppBar(props) {
        _classCallCheck(this, AppBar);

        var _this = _possibleConstructorReturn(this, (AppBar.__proto__ || Object.getPrototypeOf(AppBar)).call(this, props));

        _this.linkEvent = function (link) {
            if (link.value) _this.props.doPush(link.value.includes('entity') ? '' + link.value + _this.props.entity : link.value);
        };

        _this.mapElements = function (elements, type) {
            return elements.map(function (e) {
                return _this.mapElement(e, type);
            }).filter(function (x) {
                return x;
            });
        };

        _this.mapElement = function (e, type) {
            if (e.devices) {
                var mobile = (0, _isMobile2.default)(_this.context.screenSize);
                var tablet = (0, _isTablet2.default)(_this.context.screenSize);
                var desktop = (0, _isDesktop2.default)(_this.context.screenSize);

                if (mobile && !(e.devices.indexOf('mobile') > -1)) return;
                if (tablet && !(e.devices.indexOf('tablet') > -1)) return;
                if (desktop && !(e.devices.indexOf('desktop') > -1)) return;
            }

            var element = {
                code: e.code,
                disable: e.disable,
                text: e.label || e.code,
                clickEvent: function clickEvent() {
                    return _this.linkEvent(e);
                },
                type: type
            };

            if (type === 'link' && e.links) {
                element.elements = _this.mapElements(e.links, type);
            } else if (type === 'button') {
                element.primary = e.primary === true;
                if (e.buttons) {
                    element.elements = _this.mapElements(e.buttons, type);
                }
            }

            return element;
        };

        _this.state = {};
        return _this;
    }

    _createClass(AppBar, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var mobile = (0, _isMobile2.default)(this.context.screenSize);
            var tablet = (0, _isTablet2.default)(this.context.screenSize);
            var desktop = (0, _isDesktop2.default)(this.context.screenSize);

            var menuElements = [];
            var linkElements = [];
            var buttonElements = [];

            if (this.props.config) {
                if (this.props.config.menu) {
                    menuElements = this.mapElements(this.props.config.menu, 'menu');
                }

                if (this.props.config.links) {
                    linkElements = this.mapElements(this.props.config.links, 'link');
                }

                if (this.props.config.buttons) {
                    buttonElements = this.mapElements(this.props.config.buttons, 'button');
                }
            }

            if (mobile || tablet && !this.props.context.authenticated) {
                menuElements = [].concat(_toConsumableArray(linkElements), _toConsumableArray(menuElements), _toConsumableArray(buttonElements));
            }

            var menu = menuElements.length > 0 && _react2.default.createElement(NavMenu, {
                mobile: mobile || tablet,
                desktop: desktop,
                color: this.props.color,
                text: this.props.username ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'AppBar.greeting',
                    values: { name: this.props.username }
                }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AppBar.menu' }),
                elements: menuElements,
                displayUserName: this.props.username
            });

            var links = (tablet && this.props.context.authenticated || desktop) && linkElements.length > 0 && linkElements.map(function (link) {
                if (!link.elements) {
                    if (link.disable) {
                        return _react2.default.createElement(NavLink, {
                            key: 'appLink_' + link.code,
                            active: link.code === _this2.props.page,
                            disable: link.disable,
                            text: link.text,
                            clickEvent: function clickEvent() {},
                            color: _colors.Colors.StrokeDark,
                            hoverColor: _colors.Colors.StrokeDark
                        });
                    }
                    return _react2.default.createElement(NavLink, {
                        key: 'appLink_' + link.code,
                        active: link.code === _this2.props.page,
                        text: link.text,
                        clickEvent: link.clickEvent,
                        color: _this2.props.color,
                        hoverColor: _this2.props.hoverColor
                    });
                } else {
                    return _react2.default.createElement(NavMenu, {
                        mobile: mobile,
                        desktop: desktop,
                        color: _this2.props.color,
                        align: 'left',
                        text: link.text,
                        elements: link.elements,
                        subMenu: true,
                        mode: 'link'
                    });
                }
            });

            var liveChat = this.props.config.liveChat && _react2.default.createElement(
                ChatContainer,
                { fullHeight: true,
                    mobile: mobile,
                    desktop: desktop,
                    left: _sizes.Sizes.lg,
                    right: _sizes.Sizes.xs,
                    verticalAlignment: _alignments.Alignments.center,
                    clickEvent: function clickEvent() {
                        olark('api.box.expand');
                    }
                },
                _react2.default.createElement(_chat2.default, { primary: _colors.Colors.Primary,
                    secondary: _colors.Colors.Secondary
                })
            );

            var buttons = buttonElements.length > 0 && _react2.default.createElement(
                ButtonContainer,
                { inline: true,
                    verticalAlignment: _alignments.Alignments.center,
                    left: _sizes.Sizes.sm,
                    right: _sizes.Sizes.sm
                },
                buttonElements.map(function (button) {
                    if (!button.elements) {
                        return button.primary === true ? _react2.default.createElement(_primaryButton2.default, {
                            text: button.text,
                            left: _sizes.Sizes.xs,
                            right: _sizes.Sizes.xs,
                            clickEvent: button.clickEvent
                        }) : _react2.default.createElement(AppBarSecondaryButton, {
                            borderColor: _this2.props.borderColor,
                            inverse: _this2.props.inverse,
                            color: _this2.props.buttonColor,
                            bgColor: _this2.props.buttonBgColor,
                            text: button.text,
                            left: _sizes.Sizes.xs,
                            right: _sizes.Sizes.xs,
                            clickEvent: button.clickEvent
                        });
                    } else {
                        return _react2.default.createElement(NavMenu, {
                            mobile: mobile || tablet,
                            desktop: desktop,
                            color: _this2.props.color,
                            text: button.text,
                            elements: button.elements,
                            mode: 'button'
                        });
                    }
                })
            );

            var logoLink = '/';
            if (!this.props.context.authenticated && this.props.context.configuration && this.props.context.configuration.corporateWeb) {
                logoLink = this.props.context.configuration.corporateWeb;
            }

            return _react2.default.createElement(
                AppBarWrapper,
                _extends({ mobile: mobile,
                    afterScrollColor: this.props.afterScrollColor }, this.props),
                _react2.default.createElement(
                    AppBarComponent,
                    _extends({ mobile: mobile,
                        isVisible: this.context.scrollDirection === 'up' }, this.props),
                    _react2.default.createElement(
                        LogoWrapper,
                        { mobile: mobile },
                        _react2.default.createElement(
                            _link2.default,
                            { href: logoLink },
                            _react2.default.createElement(_light2.default, { width: this.props.logoWidth,
                                height: this.props.logoHeight
                            })
                        )
                    ),
                    desktop && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                            AppBarLinks,
                            null,
                            links
                        ),
                        liveChat,
                        buttons,
                        menu
                    ),
                    (tablet || mobile) && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(Spacer, null),
                        liveChat,
                        menu
                    )
                ),
                this.props.context.userInterface && this.props.context.userInterface.betaFeatureEnabled && _react2.default.createElement(_LanguageToggle2.default, { context: this.props.context, color: this.props.color })
            );
        }
    }]);

    return AppBar;
}(_react.Component);

AppBar.contextTypes = {
    screenSize: _propTypes2.default.string,
    scrollTop: _propTypes2.default.number,
    scrollDirection: _propTypes2.default.string
};

exports.default = (0, _scroll.withScroll)(AppBar);